import { MetaData } from "toptaal-shared"
import { z } from "zod"

interface TeachingMaterial {
  id: number
  title: string
  price: string

  type: TeachingMaterialType
  owner: TeachingMaterialOwnerType
}

type TeachingMaterials = TeachingMaterial[]

interface PaginatedTeachingMaterialsResponse {
  data: {
    teachingMaterials: TeachingMaterials
  }
  meta: MetaData
}

export const teachingMaterialTypeEnum = z.enum(
  ["print", "book", "license", "diglin"],
  {
    message: "Type is verplicht",
  },
)

export const teachingMaterialOwnerEnum = z.enum(["toptaal", "external"], {
  message: "Eigendom is verplicht",
})

export const teachingMaterialOwnerMap: Record<
  TeachingMaterialOwnerType,
  string
> = {
  toptaal: "TopTaal",
  external: "Extern",
}

export type TeachingMaterialType = z.infer<typeof teachingMaterialTypeEnum>
export type TeachingMaterialOwnerType = z.infer<
  typeof teachingMaterialOwnerEnum
>

export const teachingMaterialTypeDropdownOptions = [
  { label: "Print TopTaal", value: "print" },
  { label: "Boek", value: "book" },
  { label: "Licentie", value: "license" },
  { label: "Startmap TidB LGL A0-A1 (Diglin)", value: "diglin" },
]

export const teachingMaterialOwnerDropdownOptions = [
  { label: "TopTaal", value: "toptaal" },
  { label: "Extern", value: "external" },
]

interface TeachingMaterialInput {
  title: string
  price: string
  type: TeachingMaterialType
  owner: TeachingMaterialOwnerType
}

export type {
  TeachingMaterial,
  TeachingMaterials,
  PaginatedTeachingMaterialsResponse,
  TeachingMaterialInput,
}
